import { useCallback } from "react";
import { Task } from "@common/types/task";
import { useTasksContext } from "./tasks.context";

// Migration chains are linear, so only the first blocking edge is meaningful.
export function getNextTaskId(task: Task): string | undefined {
    return task.blockingTaskIds?.[0];
}

export function useAdvanceToNextTask() {
    const { goToTask } = useTasksContext();

    return useCallback(
        (completedTask: Task) => {
            const nextTaskId = getNextTaskId(completedTask);
            if (nextTaskId) {
                goToTask({
                    taskId: nextTaskId,
                    workspaceId: completedTask.workspaceId,
                });
            }
        },
        [goToTask],
    );
}
